import { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import {
  AppstoreOutlined,
  MailOutlined,
  PlusSquareOutlined,
  TrophyFilled,
  WeiboSquareOutlined,
  SettingOutlined,
  ReconciliationFilled,
  UnorderedListOutlined,
  BarChartOutlined
} from "@ant-design/icons";
import _ from "lodash";
import { Menu } from "antd";
import styled from "styled-components";
import { menuParent, menuLink } from "../../helper/const";
import { PATHS } from "../../layout/path/Path";
import Header from "./Header";
import { getData } from "../../utils/localStorage";
import { ToastContainer } from "react-toastify";
import { routerHiddenMenu } from "../../helper/const";
import { useDispatch } from "react-redux";
import { getDataInfoRevenue } from "../../redux/Future/Common/action";
import { apiGetInfoRevenue } from "../../api/Common";
import logoUnitel from "../../assets/images/logo-unitel.png";
import logoMytel from "../../assets/images/logo-my-tel.png";


function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}
export default function MainLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);


  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    dispatch(getDataInfoRevenue(apiGetInfoRevenue()));
  }, [location.pathname]);

  let isShowMenu = !_.includes(routerHiddenMenu, location.pathname);

  const token = getData("token");
  useEffect(() => {
    if (!token) {
      navigate(PATHS.LOGIN);
    }
  }, [token]);

  const onClick = (e) => {
    navigate(e.key);
    if (isMobile) {
      toggleCollapsed();
    }
  };

  let menuParents = "";
  menuLink.forEach(
    (item) =>
      _.includes(item.children, location.pathname) && (menuParents = item.title)
  );

  useEffect(() => {
    const menuItems = [
      getItem(
        "",
        "sub2",
        <AppstoreOutlined />,
        [
          getItem("Bitel", menuParent.bitel, <BarChartOutlined />, [
            getItem("Subasta", PATHS.BITEL_SUBASTA),
            getItem("Airtime", PATHS.BITEL_AIRTIME),
          ]),
          getItem("Mytel", menuParent.mytel, <BarChartOutlined />, [
            getItem("Vmail", PATHS.VM_MYTEL),
            getItem("Auction", PATHS.MYTEL_AUCTION),
            getItem("Magic Wheel", PATHS.MAGIC_WHEEL),
          ]),
          getItem("Unitel", menuParent.unitel, <BarChartOutlined />, [
            getItem("Vmail", PATHS.VMAIL_UNITEL),
            getItem("Game Unitel", PATHS.UNITEL_REVENUE),
          ]),
          getItem("NatCom", menuParent.natcom, <BarChartOutlined />, [
            getItem("Vmail", "natcom-vmail-parent", null, [
              getItem("Revenue", PATHS.NATCOM_VMAIL_CURRENT_MESSAGE),
              getItem("Miss Call", PATHS.NATCOM_VMAIL_MISS_CALL),
            ]),
            getItem("Ntm", PATHS.NATCOM_NTM),
            getItem("Airtime", PATHS.NATCOM_AIRTIME),
          ]),
          getItem("Việt Nam", menuParent.vietnam, <BarChartOutlined />, [
            getItem("Bicagame", PATHS.BICAGAME, null, [
              getItem("Viettel", PATHS.BICAGAME),
              getItem("Vinaphone", PATHS.BICAGAME_VINA),
            ]),
          ]),
          getItem("Halotel", menuParent.halotel, <BarChartOutlined />, [
            getItem("Halogame", PATHS.HALOTEL_HALOGAME, <BarChartOutlined />),
          ]),
          getItem("Config", menuParent.config, <SettingOutlined />, [
            getItem("Config Alert", PATHS.CONFIG_ALERT),
          ]),
        ],
        "group"
      ),
      { type: "divider" },
    ];

    setItems(menuItems);
  }, [location.pathname]);   

//   const items = [
//     getItem(
//       "",
//       "sub2",
//       <AppstoreOutlined />,
//       [
//         getItem("Bitel", menuParent.bitel, <BarChartOutlined />, [
//           getItem("Subasta", PATHS.BITEL_SUBASTA),
//           getItem("Airtime", PATHS.BITEL_AIRTIME),
//         ]),
//         getItem("Mytel", menuParent.mytel, <BarChartOutlined />, [
//           getItem("Vmail", PATHS.VM_MYTEL),
//           getItem("Auction", PATHS.MYTEL_AUCTION),
//           getItem("Magic Wheel", PATHS.MAGIC_WHEEL),
//           // getItem("Error code", PATHS.MYTEL_ERROR_CODE),
//         ]),
//         getItem("Unitel", menuParent.unitel, <BarChartOutlined />, [
//           getItem("Vmail", PATHS.VMAIL_UNITEL),
//           getItem("Game Unitel", PATHS.UNITEL_REVENUE),
//         ]),
//         getItem("NatCom", menuParent.natcom, <BarChartOutlined />, [
//           getItem("Vmail", PATHS.VMAIL_NTM_AIRTIME),
//           getItem("Ntm", PATHS.NATCOM_NTM),
//           getItem("Airtime", PATHS.NATCOM_AIRTIME),
//         ]),
// 
//         getItem("Halogame", PATHS.HALOTEL_HALOGAME, <BarChartOutlined />),
//         getItem("Bicagame", PATHS.BICAGAME, <BarChartOutlined />),
// 
//         getItem("Config", menuParent.config, <SettingOutlined />, [
//           getItem("Config Alert", PATHS.CONFIG_ALERT),
//         ]),
//         
//       ],
//       "group"
//     ),
// 
//     { type: "divider" },
//   ];

  return (
    <>
      {isShowMenu && (
        <>
          <div className="header">
            <Header toggleCollapsed={toggleCollapsed} collapsed={collapsed} />
          </div>
          {collapsed || !isMobile ? (
            <div className="main-layout">
              {isMobile ? (
                <div className="close-menu" onClick={toggleCollapsed}>
                  <i className="fa fa-times" aria-hidden="true" />
                </div>
              ) : (
                <></>
              )}
              <Container
                onClick={onClick}
                style={{ width: 256 }}
                defaultSelectedKeys={[location.pathname]}
                defaultOpenKeys={[menuParents]}
                mode="inline"
                // inlineCollapsed={collapsed}
                items={items}
              />
            </div>
          ) : (
            <></>
          )}
        </>
      )}
      <main
        className={`${isShowMenu ? "container-item main" : ""} ${
          !collapsed && isMobile ? "m-0 w-100" : ""
        }`}
      >
        <Outlet />
        <ToastContainer />
      </main>
    </>
  );
}

const Container = styled(Menu)`
  height: 100vh;
  background-image: linear-gradient(
    270deg,
    rgba(51, 148, 225, 0.18),
    transparent
  );
  padding-top: 60px;
  background-color: #2c3a47;
  color: #e2dbdb;
  overflow-y: auto;
  scrollbar-width: none; 
  -ms-overflow-style: none; 
  overflow: auto;

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }

  .ant-menu-item-selected .anticon-mail svg {
    color: #474747 !important;
  }


  .ant-menu-item:hover {
    color: white !important;
  }
  .ant-menu-item-divider {
    opacity: 0;
  }

  .ant-menu-item-group-title {
    color: #e2dbdb;
    font-size: 30px;
  }
  .ant-menu-item-only-child .ant-menu-title-content {
    color: #e2dbdb !important;
  }

  .ant-menu-item-selected .ant-menu-title-content {
    color: black !important;
  }

  .ant-menu-submenu-selected {
    .ant-menu-title-content,
    span,
    svg,
    i {
      color: white;
    }
  }

  @media (max-width: 768px) {
    margin-top: 40px;
    padding-left: 20px;
    padding-right: 20px;
  }
`;
